import { useMemo } from 'react';
import { Control, useWatch } from 'react-hook-form';

import type { StepThreeTab } from '../validations/add-template.validation';
import type { TemplateFormSchema } from '../validations/edit-template.validation';

import { VariableMappingType } from '../enums/mapping-editor.const';
import {
  fieldMappingEqual,
  fieldMappingTypesEqual,
  tabsEqual,
} from '../utils/step-three-equality.util';

type InitialSnapshot = {
  fieldMapping: Record<string, string>;
  fieldMappingTypes: Record<string, VariableMappingType>;
  tabs: StepThreeTab[];
};

export const useHasModalChanges = (
  control: Control<TemplateFormSchema>,
  initial: InitialSnapshot | undefined,
): boolean => {
  const fieldMapping = useWatch({
    control,
    name: 'stepThree.fieldMapping',
    defaultValue: {},
  });

  const fieldMappingTypes = useWatch({
    control,
    name: 'stepThree.fieldMappingTypes',
    defaultValue: {},
  });

  const tabsWatch = useWatch({
    control,
    name: 'stepThree.tabs',
    defaultValue: [],
  });
  const tabs = useMemo(() => tabsWatch ?? [], [tabsWatch]);

  return useMemo(() => {
    if (!initial) return true;
    return (
      !fieldMappingEqual(fieldMapping ?? {}, initial.fieldMapping) ||
      !fieldMappingTypesEqual(fieldMappingTypes ?? {}, initial.fieldMappingTypes) ||
      !tabsEqual(tabs, initial.tabs)
    );
  }, [fieldMapping, fieldMappingTypes, initial, tabs]);
};
